import { State } from './types';

export const initialState: State = {
  ssoAppsList: {
    data: [],
    loading: false,
    error: null,
  },
};
